import type { KeycloakTokenParsed } from 'keycloak-js';

import UserModel from '../models/standard/UserModel';

export const REQUIRED_FLOORPLANNER_MODULE = 'planner';

export interface ImmersightKeycloakClaims extends KeycloakTokenParsed {
  administration?: number;
  email?: string;
  family_name?: string;
  given_name?: string;
  is_showroom_owner?: boolean;
  modules?: string[];
  name?: string;
  platform_roles?: string;
  preferred_username?: string;
  showroom_id?: number;
  showroom_ids?: string[];
  showroom_owner_user_id?: number;
  user_id?: number;
  country?: string;
  locale?: string;
}

const stringifyClaim = (value: unknown): string => {
  if (value === null || value === undefined) {
    return '';
  }

  return String(value);
};

export const hasRequiredFloorplannerModule = (tokenParsed?: KeycloakTokenParsed): boolean => {
  const modules = (tokenParsed as ImmersightKeycloakClaims | undefined)?.modules;

  return Array.isArray(modules) && modules.includes(REQUIRED_FLOORPLANNER_MODULE);
};

export const createUserModelFromKeycloak = (
  token: string,
  tokenParsed?: KeycloakTokenParsed,
  previousUserData?: UserModel,
): UserModel => {
  const claims = (tokenParsed || {}) as ImmersightKeycloakClaims;
  const email = claims.email || claims.preferred_username || previousUserData?.email || '';
  const userId = stringifyClaim(claims.user_id || claims.showroom_owner_user_id || claims.sub || previousUserData?.id);

  return new UserModel(
    token,
    claims.locale || previousUserData?.localization || 'de_DE',
    email,
    claims.given_name || previousUserData?.firstName || '',
    claims.family_name || previousUserData?.lastName || '',
    previousUserData?.company || '',
    userId,
    previousUserData?.profileImageId || '',
    previousUserData?.profileImageDataId || '',
    previousUserData?.versionMajor || '0',
    previousUserData?.versionMinor || '0',
    claims.country || previousUserData?.country || '',
  );
};
